import Icon from 'lqa-ui/lib/Components/Icon';
import React from 'react';
import { Headline3, Body3 } from './../../app/common/typography';
import {
  PageContainer,
  HeaderContainer,
  TextContainer,
  ContinueContainer,
  TickPointsIcon,
} from './ForgotPasswordSuccess.styled';

const Success = () => {
  return (
    <PageContainer>
      <TickPointsIcon>
        <Icon kind="tick-points" width={80} height={80} />
      </TickPointsIcon>
      <HeaderContainer>
        <Headline3 color="white">You're all set</Headline3>
      </HeaderContainer>
      <TextContainer>
        <Body3 color="white">Your password has Changed Successfully.</Body3>
      </TextContainer>
      <ContinueContainer
        onClick={() => {
          window.location.href = '/login';
        }}
      >
        <Headline3 color="white">Back to Sign In</Headline3>
      </ContinueContainer>
    </PageContainer>
  );
};

export default Success;
